export default "__VITE_ASSET__hG4_Qzao__"